import { useCallback, useEffect, useState } from 'react';

import { type Environment } from '../server/utils/environment';
import {
	type ArkoseOnCompleted,
	type ArkoseOnError,
	type ArkoseOnReady,
	setupArkose,
	teardownArkose,
} from '../server/vendors';

export const SELECTOR = 'arkose-target';

export interface ArkoseProps {
	environment: Environment;
	onCompleted: ArkoseOnCompleted;
}

export function Arkose(props: ArkoseProps) {
	const { environment, onCompleted } = props;
	const [initialized, setInitialized] = useState<boolean>(false);
	const [errored, setErrored] = useState<boolean>(false);

	const wrappedOnCompleted = useCallback<ArkoseOnCompleted>(
		(sessionToken: string) => {
			teardownArkose();
			onCompleted(sessionToken);
		},
		[onCompleted],
	);

	const onReady = useCallback<ArkoseOnReady>(() => {
		setInitialized(true);
	}, [setInitialized]);

	const onError = useCallback<ArkoseOnError>(() => {
		setErrored(true);
		teardownArkose();
	}, [setErrored]);

	useEffect(() => {
		if (!initialized && !errored) {
			teardownArkose();
			setupArkose({ environment, onReady, onCompleted: wrappedOnCompleted, onError });
		}
	}, [environment, errored, initialized, onReady, wrappedOnCompleted, onError]);

	return <div data-testid={SELECTOR} id={SELECTOR}></div>;
}
